<h2 style="margin-top: 10px">言語切り替え：{{ 'hello.world' | translate }}</h2>
<div class="component-area" style="display: flex">
  <asw-debug-language-switch></asw-debug-language-switch>
</div>

<h2>PopupIndicator Pipe</h2>
<div class="component-area">
  <h3>Before</h3>
  <div [innerHTML]="'test.popupIndicatorPipe' | translate"></div>
  <div [innerHTML]="'test.popupIndicatorPipe3' | translate"></div>
  <div [innerHTML]="'test.popupIndicatorPipe4' | translate"></div>
  <h3>After</h3>
  <div [innerHTML]="'test.popupIndicatorPipe' | translate | popupIndicator"></div>
  <div [innerHTML]="'test.popupIndicatorPipe3' | translate | popupIndicator"></div>
  <div [innerHTML]="'test.popupIndicatorPipe4' | translate | popupIndicator"></div>
</div>

<h2>エラーハンドリング</h2>
<div class="component-area">
  <asw-button type="tertiary" size="xs" (click$)="submitFormValidate()">submit form validation error</asw-button>
  <asw-button type="tertiary" size="xs" (click$)="setRetryableError()">retryable error</asw-button>
  <br />
  <asw-button type="tertiary" size="xs" (click$)="setNotReBusinessLogicError()"
    >not retryable error (businessLogic)</asw-button
  >
  <asw-button type="tertiary" size="xs" (click$)="setNotReSystemError()">not retryable error (system)</asw-button>
  <asw-button type="tertiary" size="xs" (click$)="setNotReSessionTimeoutError()"
    >not retryable error (sessionTimeout)</asw-button
  >
  <asw-button type="tertiary" size="xs" (click$)="setNotReBrowserBackError()"
    >not retryable error (browserBack)</asw-button
  >
</div>

<h2>動的文言テスト</h2>
<div class="component-area">
  <asw-button type="tertiary" size="xs" (click$)="changeDynamicCondition()">change condition</asw-button>
  <ng-container *ngFor="let dynamic of (dynamicData$ | async) ? (dynamicData$ | async)!['1'] : []">
    <p>{{ '【messageType:1】' + (dynamic | translate) }}</p>
  </ng-container>
  <ng-container *ngFor="let dynamic of (dynamicData$ | async) ? (dynamicData$ | async)!['2'] : []">
    <p>{{ '【messageType:2】' + (dynamic | translate) }}</p>
  </ng-container>
</div>

<h2>ログ出力テスト</h2>
<div class="component-area">
  <asw-button type="tertiary" size="xs" (click$)="sendLogWithMask()">send log test</asw-button>
</div>

<h2>多重リクエスト防止テスト</h2>
<div class="component-area">
  <asw-button type="tertiary" size="xs" (click$)="sendMultiple()">send multiple (not using throttleClick)</asw-button>
  <asw-button type="tertiary" size="xs" throttleClick (click$)="sendMultiple()"
    >send multiple (default: 500ms)</asw-button
  >
  <asw-button type="tertiary" size="xs" throttleClick [throttleTime]="1000" (click$)="sendMultiple()"
    >send multiple (set throttleTime: 1000ms)</asw-button
  >
  <button id="test_button_throttleClick" aswThrottleClick (throttleClick$)="sendMultiple()">
    normal button send multiple (default: 500ms)
  </button>
</div>

<!-- 共通ダイアログ -->
<h2>共通ダイアログ</h2>
<div class="component-area">
  <asw-button (click$)="openDialogChoice()">Choice</asw-button>
  <asw-button (click$)="openDialogWarn()">Warn</asw-button>
</div>

<!-- Input -->
<h2>Input</h2>
<h3>※FormControl利用するとき、disableの制御はFormControl側のdisabled/disable()で行ってください</h3>
<div class="component-area">
  <form [formGroup]="inputFG">
    <h3>######## 表示タイプ: 通常</h3>
    <h4>未入力 + 桁数(min : 3, max : 5) （ValidationError）</h4>
    <h4>入力値変換: 搭乗者名変換</h4>
    <h4>autocomplete属性: 指定あり</h4>
    <asw-input
      label="input1"
      formControlName="inputFC"
      maxlength="5"
      required
      conversionType="paxName"
      autocomplete="on"
    ></asw-input>
    <h4>未入力(custom message) + 電話番号(国番号:81, SMS送信対象) （ValidationError）</h4>
    <h4>ペースト禁止</h4>
    <asw-input label="input2" formControlName="inputFC_2" required disablePaste></asw-input>
    <asw-button type="tertiary" size="xs" (click$)="testFormValidateSubmit()"
      >formGroup validation check onsubmit</asw-button
    >
    <h4>メールアドレス</h4>
    <asw-input label="input-email" formControlName="inputFC_3"></asw-input>
  </form>

  <h3>######## 表示タイプ: 通常 状態: disable</h3>
  <asw-input label="input" placeholder="Strings" value="test" disabled></asw-input>

  <h3>######## 表示タイプ: 通常 入力種類: password</h3>
  <asw-input label="input" placeholder="Strings" value="test" type="password"></asw-input>

  <h3>######## 表示タイプ: 電話番号（国コード付き）</h3>
  <h4>入力値変換: 電話番号変換</h4>
  <asw-input label="Phone Number" phoneCode="+81" displayType="phone" conversionType="phoneNumber"></asw-input>

  <h3>######## 表示タイプ: tooltip付き</h3>
  <asw-input label="input" placeholder="Strings" displayType="tooltip" tooltipContent="予約可能"> </asw-input>
</div>

<!-- Select -->
<h2>Select</h2>
<h3>※FormControl利用するとき、disableの制御はFormControl側のdisabled/disable()で行ってください</h3>
<div class="component-area">
  <h3>######## 状態: value値が有効な項目を選択時</h3>
  <h4>未入力（ValidationError）</h4>
  <asw-select label="label" [formControl]="selectFC" required>
    <option value="">{{ 'm_static_message-label.yearPulldown' | translate }}</option>
    <option value="option1">option1</option>
    <option value="option2">option2</option>
    <option value="option3">option3</option>
  </asw-select>
  <h3>######## 状態: disabled</h3>
  <asw-select label="label" [formControl]="selectFC_disable">
    <option value="">{{ 'm_static_message-label.yearPulldown' | translate }}</option>
    <option value="option1">option1</option>
    <option value="option2">option2</option>
    <option value="option3">option3</option>
  </asw-select>
</div>

<!-- SelectDateYm -->
<h2>SelectDateYm</h2>
<div class="component-area">
  <h3>######## select group (2つ並び) value: {{ selectYmControl.value }}</h3>
  <h4>未入力（ValidationError）</h4>
  <asw-select-date-ym [formControl]="selectYmControl" [yearRange]="[2023, 2099]"></asw-select-date-ym>
</div>

<!-- RadioButton -->
<h2>RadioButton</h2>
<h3>※FormControl利用するとき、disableの制御はFormControl側のdisabled/disable()で行ってください</h3>
<div class="component-area">
  <h3>######## 単体</h3>
  <asw-radio-group name="radiobutton_1">
    <asw-radio-button value="1" label="Strings HiddenLabel_1" isHidden></asw-radio-button>
    <asw-radio-button value="2" label="Strings HiddenLabel_2" isHidden></asw-radio-button>
  </asw-radio-group>

  <h3>######## 文字あり</h3>
  <asw-radio-group name="radiobutton_2">
    <asw-radio-button value="1" label="Strings1"></asw-radio-button>
    <asw-radio-button value="2" label="Strings2"></asw-radio-button>
  </asw-radio-group>

  <h3>######## 横並びリスト 状態: 未選択（ValidationError）</h3>
  <asw-radio-group name="radiobutton_4" [formControl]="radiobuttonFC" required>
    <asw-radio-button value="1" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="2" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="3" label="Strings Strings Strings Strings Strings Strings"></asw-radio-button>
    <asw-radio-button value="4" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="5" label="Strings Strings"></asw-radio-button>
  </asw-radio-group>

  <h3>######## 横並びリスト 状態: 選択済み</h3>
  <asw-radio-group name="radiobutton_7" [formControl]="radiobuttonFC_2">
    <asw-radio-button value="1" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="2" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="3" label="Strings Strings Strings Strings Strings Strings"></asw-radio-button>
    <asw-radio-button value="4" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="5" label="Strings Strings"></asw-radio-button>
  </asw-radio-group>

  <h3>######## 横並びリスト（SPのみ縦並び）</h3>
  <asw-radio-group name="radiobutton_6" label="ラジオ縦並びリスト" direction="sp-vertical">
    <asw-radio-button value="1" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="2" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="3" label="Strings Strings Strings Strings Strings Strings"></asw-radio-button>
    <asw-radio-button value="4" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="5" label="Strings Strings"></asw-radio-button>
  </asw-radio-group>

  <h3>######## 縦並びリスト</h3>
  <asw-radio-group name="radiobutton_3" selected="4" direction="vertical">
    <asw-radio-button value="1" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="2" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="3" label="Strings Strings Strings Strings Strings Strings"></asw-radio-button>
    <asw-radio-button value="4" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="5" label="Strings Strings"></asw-radio-button>
  </asw-radio-group>

  <h3>######## 縦並びリスト 状態: disabled</h3>
  <asw-radio-group name="radiobutton_5" selected="4" direction="vertical" disabled>
    <asw-radio-button value="1" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="2" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="3" label="Strings Strings Strings Strings Strings Strings"></asw-radio-button>
    <asw-radio-button value="4" label="Strings Strings"></asw-radio-button>
    <asw-radio-button value="5" label="Strings Strings"></asw-radio-button>
  </asw-radio-group>
</div>

<!-- CheckBox -->
<h2>CheckBox</h2>
<h3>※FormControl利用するとき、disableの制御はFormControl側のdisabled/disable()で行ってください</h3>
<div class="component-area">
  <h3>######## 単体 状態: 未選択（ValidationError）</h3>
  <asw-checkbox [formControl]="checkBoxFC" label="Strings HiddenLabel" isHidden></asw-checkbox>

  <h3>######## 単体 状態: disabled</h3>
  <asw-checkbox disabled label="Strings HiddenLabel" isHidden></asw-checkbox>

  <h3>######## 単体 状態: disabled(チェックあり)</h3>
  <asw-checkbox disabled checked label="Strings HiddenLabel" isHidden></asw-checkbox>

  <h3>######## 文字あり 状態: 未選択（必須表示なし）</h3>
  <asw-checkbox label="Strings"></asw-checkbox>

  <h3>######## 文字あり 状態: 未選択（必須表示あり＋ValidationError）</h3>
  <asw-checkbox [formControl]="checkBoxFC_2" label="Strings" required></asw-checkbox>

  <h3>######## 文字あり 状態: disabled</h3>
  <asw-checkbox label="Strings" disabled></asw-checkbox>

  <h3>######## 文字あり 状態: disabled(チェックあり)</h3>
  <asw-checkbox label="Strings" disabled checked></asw-checkbox>

  <h3>######## 横並びリスト 状態: 未選択（ValidationError）</h3>
  <asw-checkbox-group [formControl]="checkBoxGroupFC_1" required>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings Strings Strings Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
  </asw-checkbox-group>

  <h3>######## 横並びリスト 状態:disabled</h3>
  <asw-checkbox-group disabled>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings Strings Strings Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
  </asw-checkbox-group>

  <h3>######## 横並びリスト（SPのみ縦並び） 状態: 選択済み</h3>
  <asw-checkbox-group direction="sp-vertical" [formControl]="checkBoxGroupFC_2">
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings Strings Strings Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
  </asw-checkbox-group>

  <h3>######## 縦並びリスト 状態: 選択済み</h3>
  <asw-checkbox-group direction="vertical" [formControl]="checkBoxGroupFC_3">
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings Strings Strings Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
    <asw-checkbox label="Strings Strings"></asw-checkbox>
  </asw-checkbox-group>
</div>

<!-- Button -->
<h2>Button</h2>
<div class="component-area">
  <h3>######## Type: default (primary)</h3>
  <div>
    <h4></h4>
    <asw-button ariaLabel="{{ 'm_static_message-label.confirm' | translate }}">button</asw-button>
    <asw-button size="s">s size</asw-button>
    <asw-button size="s-min-w100">s-min-w100</asw-button>
    <asw-button size="xs">xs size</asw-button>

    <h4>disabled</h4>
    <asw-button disabled>button</asw-button>
    <asw-button size="s" disabled>s size</asw-button>
    <asw-button size="s-min-w100" disabled>s-min-w100</asw-button>
    <asw-button size="xs" disabled>xs size</asw-button>

    <h4>icon="next"</h4>
    <asw-button icon="next">button</asw-button>
    <asw-button size="s" icon="next">s size</asw-button>
    <asw-button size="s-min-w100" icon="next">s-min-w100</asw-button>
    <asw-button size="xs" icon="next">xs size</asw-button>

    <h4>icon="next" disabled</h4>
    <asw-button icon="next" disabled>button</asw-button>
    <asw-button size="s" icon="next" disabled>s size</asw-button>
    <asw-button size="s-min-w100" icon="next" disabled>s-min-w100</asw-button>
    <asw-button size="xs" icon="next" disabled>xs size</asw-button>

    <h4>icon="external"</h4>
    <asw-button icon="external">button</asw-button>
    <asw-button size="s" icon="external">s size</asw-button>
    <asw-button size="s-min-w100" icon="external">s-min-w100</asw-button>
    <asw-button size="xs" icon="external">xs size</asw-button>

    <h4>icon="external" disabled</h4>
    <asw-button icon="external" disabled>button</asw-button>
    <asw-button size="s" icon="external" disabled>s size</asw-button>
    <asw-button size="s-min-w100" icon="external" disabled>s-min-w100</asw-button>
    <asw-button size="xs" icon="external" disabled>xs size</asw-button>
  </div>
  <h3>######## Type: secondary</h3>
  <div>
    <h4></h4>
    <asw-button type="secondary">button</asw-button>
    <asw-button type="secondary" size="s">s size</asw-button>
    <asw-button type="secondary" size="s-min-w100">s-min-w100</asw-button>
    <asw-button type="secondary" size="xs">xs size</asw-button>

    <h4>disabled</h4>
    <asw-button type="secondary" disabled>button</asw-button>
    <asw-button type="secondary" size="s" disabled>s size</asw-button>
    <asw-button type="secondary" size="s-min-w100" disabled>b100</asw-button>
    <asw-button type="secondary" size="xs" disabled>xs size</asw-button>

    <h4>icon="next"</h4>
    <asw-button type="secondary" icon="next">button</asw-button>
    <asw-button type="secondary" size="s" icon="next">s size</asw-button>
    <asw-button type="secondary" size="s-min-w100" icon="next">s-min-w100</asw-button>
    <asw-button type="secondary" size="xs" icon="next">xs size</asw-button>

    <h4>icon="next" disabled</h4>
    <asw-button type="secondary" icon="next" disabled>button</asw-button>
    <asw-button type="secondary" size="s" icon="next" disabled>s size</asw-button>
    <asw-button type="secondary" size="s-min-w100" icon="next" disabled>s-min-w100</asw-button>
    <asw-button type="secondary" size="xs" icon="next" disabled>xs size</asw-button>

    <h4>icon="external"</h4>
    <asw-button type="secondary" icon="external">button</asw-button>
    <asw-button type="secondary" size="s" icon="external">s size</asw-button>
    <asw-button type="secondary" size="s-min-w100" icon="external">s-min-w100</asw-button>
    <asw-button type="secondary" size="xs" icon="external">xs size</asw-button>

    <h4>icon="external" disabled</h4>
    <asw-button type="secondary" icon="external" disabled>button</asw-button>
    <asw-button type="secondary" size="s" icon="external" disabled>s size</asw-button>
    <asw-button type="secondary" size="s-min-w100" icon="external" disabled>s-min-w100</asw-button>
    <asw-button type="secondary" size="xs" icon="external" disabled>xs size</asw-button>
  </div>
  <h3>######## Type: tertiary</h3>
  <div>
    <h4></h4>
    <asw-button type="tertiary">button</asw-button>
    <asw-button type="tertiary" size="s">s size</asw-button>
    <asw-button type="tertiary" size="s-min-w100">s-min-w100</asw-button>
    <asw-button type="tertiary" size="xs">xs size</asw-button>

    <h4>disabled</h4>
    <asw-button type="tertiary" disabled>button</asw-button>
    <asw-button type="tertiary" size="s" disabled>s size</asw-button>
    <asw-button type="tertiary" size="s-min-w100" disabled>s-min-w100</asw-button>
    <asw-button type="tertiary" size="xs" disabled>xs size</asw-button>

    <h4>icon="next"</h4>
    <asw-button type="tertiary" icon="next">button</asw-button>
    <asw-button type="tertiary" size="s" icon="next">s size</asw-button>
    <asw-button type="tertiary" size="s-min-w100" icon="next">s-min-w100</asw-button>
    <asw-button type="tertiary" size="xs" icon="next">xs size</asw-button>

    <h4>icon="next" disabled</h4>
    <asw-button type="tertiary" icon="next" disabled>button</asw-button>
    <asw-button type="tertiary" size="s" icon="next" disabled>s size</asw-button>
    <asw-button type="tertiary" size="s-min-w100" icon="next" disabled>s-min-w100</asw-button>
    <asw-button type="tertiary" size="xs" icon="next" disabled>xs size</asw-button>

    <h4>icon="external"</h4>
    <asw-button type="tertiary" icon="external">button</asw-button>
    <asw-button type="tertiary" size="s" icon="external">s size</asw-button>
    <asw-button type="tertiary" size="s-min-w100" icon="external">s-min-w100</asw-button>
    <asw-button type="tertiary" size="xs" icon="external">xs size</asw-button>

    <h4>icon="external" disabled</h4>
    <asw-button type="tertiary" icon="external" disabled>button</asw-button>
    <asw-button type="tertiary" size="s" icon="external" disabled>s size</asw-button>
    <asw-button type="tertiary" size="s-min-w100" icon="external" disabled>s-min-w100</asw-button>
    <asw-button type="tertiary" size="xs" icon="external" disabled>xs size</asw-button>
  </div>
  <h3>######## Type: quaternary</h3>
  <div style="background-color: whitesmoke">
    <h4></h4>
    <asw-button type="quaternary">button</asw-button>
    <asw-button type="quaternary" size="s">s size</asw-button>
    <asw-button type="quaternary" size="s-min-w100">s-min-w100</asw-button>
    <asw-button type="quaternary" size="xs">xs size</asw-button>

    <h4>disabled</h4>
    <asw-button type="quaternary" disabled>button</asw-button>
    <asw-button type="quaternary" size="s" disabled>s size</asw-button>
    <asw-button type="quaternary" size="s-min-w100" disabled>s-min-w100</asw-button>
    <asw-button type="quaternary" size="xs" disabled>xs size</asw-button>

    <h4>icon="next"</h4>
    <asw-button type="quaternary" icon="next">button</asw-button>
    <asw-button type="quaternary" size="s" icon="next">s size</asw-button>
    <asw-button type="quaternary" size="s-min-w100" icon="next">s-min-w100</asw-button>
    <asw-button type="quaternary" size="xs" icon="next">xs size</asw-button>

    <h4>icon="next" disabled</h4>
    <asw-button type="quaternary" icon="next" disabled>button</asw-button>
    <asw-button type="quaternary" size="s" icon="next" disabled>s size</asw-button>
    <asw-button type="quaternary" size="s-min-w100" icon="next" disabled>s-min-w100</asw-button>
    <asw-button type="quaternary" size="xs" icon="next" disabled>xs size</asw-button>

    <h4>icon="external"</h4>
    <asw-button type="quaternary" icon="external">button</asw-button>
    <asw-button type="quaternary" size="s" icon="external">s size</asw-button>
    <asw-button type="quaternary" size="s-min-w100" icon="external">s-min-w100</asw-button>
    <asw-button type="quaternary" size="xs" icon="external">xs size</asw-button>

    <h4>icon="external" disabled</h4>
    <asw-button type="quaternary" icon="external" disabled>button</asw-button>
    <asw-button type="quaternary" size="s" icon="external" disabled>s size</asw-button>
    <asw-button type="quaternary" size="s-min-w100" icon="external" disabled>s-min-w100</asw-button>
    <asw-button type="quaternary" size="xs" icon="external" disabled>xs size</asw-button>
  </div>
  <h3>######## Type: warn</h3>
  <div>
    <h4></h4>
    <asw-button type="warn">button</asw-button>
    <asw-button type="warn" size="s">s size</asw-button>
    <asw-button type="warn" size="s-min-w100">s-min-w100</asw-button>
    <asw-button type="warn" size="xs">xs size</asw-button>

    <h4>disabled</h4>
    <asw-button type="warn" disabled>button</asw-button>
    <asw-button type="warn" size="s" disabled>s size</asw-button>
    <asw-button type="warn" size="s-min-w100" disabled>s-min-w100</asw-button>
    <asw-button type="warn" size="xs" disabled>xs size</asw-button>

    <h4>icon="next"</h4>
    <asw-button type="warn" icon="next">button</asw-button>
    <asw-button type="warn" size="s" icon="next">s size</asw-button>
    <asw-button type="warn" size="s-min-w100" icon="next">s-min-w100</asw-button>
    <asw-button type="warn" size="xs" icon="next">xs size</asw-button>

    <h4>icon="next" disabled</h4>
    <asw-button type="warn" icon="next" disabled>button</asw-button>
    <asw-button type="warn" size="s" icon="next" disabled>s size</asw-button>
    <asw-button type="warn" size="s-min-w100" icon="next" disabled>s-min-w100</asw-button>
    <asw-button type="warn" size="xs" icon="next" disabled>xs size</asw-button>

    <h4>icon="external"</h4>
    <asw-button type="warn" icon="external">button</asw-button>
    <asw-button type="warn" size="s" icon="external">s size</asw-button>
    <asw-button type="warn" size="s-min-w100" icon="external">s-min-w100</asw-button>
    <asw-button type="warn" size="xs" icon="external">xs size</asw-button>

    <h4>icon="external" disabled</h4>
    <asw-button type="warn" icon="external" disabled>button</asw-button>
    <asw-button type="warn" size="s" icon="external" disabled>s size</asw-button>
    <asw-button type="warn" size="s-min-w100" icon="external" disabled>s-min-w100</asw-button>
    <asw-button type="warn" size="xs" icon="external" disabled>xs size</asw-button>
  </div>
  <h3>######## Type: secondary warn</h3>
  <div>
    <h4></h4>
    <asw-button type="warn-secondary">button</asw-button>
    <asw-button type="warn-secondary" size="s">s size</asw-button>
    <asw-button type="warn-secondary" size="s-min-w100">s-min-w100</asw-button>
    <asw-button type="warn-secondary" size="xs">xs size</asw-button>

    <h4>disabled</h4>
    <asw-button type="warn-secondary" disabled>button</asw-button>
    <asw-button type="warn-secondary" size="s" disabled>s size</asw-button>
    <asw-button type="warn-secondary" size="s-min-w100" disabled>s-min-w100</asw-button>
    <asw-button type="warn-secondary" size="xs" disabled>xs size</asw-button>

    <h4>icon="next"</h4>
    <asw-button type="warn-secondary" icon="next">button</asw-button>
    <asw-button type="warn-secondary" size="s" icon="next">s size</asw-button>
    <asw-button type="warn-secondary" size="s-min-w100" icon="next">s-min-w100</asw-button>
    <asw-button type="warn-secondary" size="xs" icon="next">xs size</asw-button>

    <h4>icon="next" disabled</h4>
    <asw-button type="warn-secondary" icon="next" disabled>button</asw-button>
    <asw-button type="warn-secondary" size="s" icon="next" disabled>s size</asw-button>
    <asw-button type="warn-secondary" size="s-min-w100" icon="next" disabled>s-min-w100</asw-button>
    <asw-button type="warn-secondary" size="xs" icon="next" disabled>xs size</asw-button>

    <h4>icon="external"</h4>
    <asw-button type="warn-secondary" icon="external">button</asw-button>
    <asw-button type="warn-secondary" size="s" icon="external">s size</asw-button>
    <asw-button type="warn-secondary" size="s-min-w100" icon="external">s-min-w100</asw-button>
    <asw-button type="warn-secondary" size="xs" icon="external">xs size</asw-button>

    <h4>icon="external" disabled</h4>
    <asw-button type="warn-secondary" icon="external" disabled>button</asw-button>
    <asw-button type="warn-secondary" size="s" icon="external" disabled>s size</asw-button>
    <asw-button type="warn-secondary" size="s-min-w100" icon="external" disabled>s-min-w100</asw-button>
    <asw-button type="warn-secondary" size="xs" icon="external" disabled>xs size</asw-button>
  </div>
</div>

<!-- RangeSlider -->
<h2>RangeSlider</h2>
<h3>※FormControl利用するとき、disableの制御はFormControl側のdisabled/disable()で行ってください</h3>
<div class="component-area">
  <h3>######## スライダーのタイプ: 金額</h3>
  <h4>slider value: {{ rangeSliderFC.value }}</h4>
  <asw-range-slider
    type="amount"
    ariaLabel="test_sliderAriaLabel"
    handlePoint="one"
    valueMin="-820.40"
    valueMax="2560.25"
    unitFront=""
    unitBack="h"
    [formControl]="rangeSliderFC"
  >
  </asw-range-slider>
  <h3>######## スライダーのタイプ: 金額（非活性）</h3>
  <asw-range-slider
    type="amount"
    ariaLabel="test_sliderAriaLabel"
    handlePoint="one"
    valueMin="-820.40"
    valueMax="2560.25"
    unitFront=""
    unitBack="h"
    disabled
  >
  </asw-range-slider>
  <h3>######## スライダーのタイプ: 時間（例：乗り継ぎ時間など）</h3>
  <h4>slider value: {{ rangeSliderFC_2.value }}</h4>
  <asw-range-slider
    type="interval"
    ariaLabel="test_sliderAriaLabel"
    valueMin="135"
    valueMax="315"
    stepGrid="15"
    unitFront=""
    unitBack="h"
    [formControl]="rangeSliderFC_2"
  >
  </asw-range-slider>
  <h3>######## スライダーのタイプ: 時間（非活性）</h3>
  <asw-range-slider
    type="interval"
    ariaLabel="test_sliderAriaLabel"
    valueMin="135"
    valueMax="315"
    stepGrid="15"
    unitFront=""
    unitBack="h"
    disabled
  >
  </asw-range-slider>
  <h3>######## スライダーのタイプ: 時刻</h3>
  <h4>slider value: {{ rangeSliderFC_3.value }}</h4>
  <asw-range-slider
    type="time"
    ariaLabel="test_sliderAriaLabel"
    valueMin="1215"
    stepGrid="15"
    unitFront=""
    unitBack="h"
    [formControl]="rangeSliderFC_3"
  >
  </asw-range-slider>
  <h3>######## スライダーのタイプ: 時刻（非活性）</h3>
  <asw-range-slider
    type="time"
    ariaLabel="test_sliderAriaLabel"
    valueMin="1215"
    stepGrid="15"
    unitFront=""
    unitBack="h"
    disabled
  >
  </asw-range-slider>
</div>

<h2>Tooltip</h2>
<div class="component-area" style="margin-bottom: 20px">
  <h3>######## ツールチップ表示方式: アイコン押下</h3>
  <asw-tooltip
    iconImage='<img src={{appConstants.IMG.ALL_HELP_PRIMARY}} alt="tooltip" width="20" height="20">'
    tooltipContent='<p>運航便によりご利用のターミナルが異なりますのでご注意ください。
      <a href="#">羽田空港の発着ターミナルについて<img src="/../assets/images/icon_external_primary_16.svg" class="c-text-link-external" alt="test" width="16" height="16"></a>をご確認ください。</p>'
    [tooltipTop]="0"
  >
  </asw-tooltip>
  <span *ngFor="let i of [2, 3, 4, 5, 6, 7, 8, 9, 10]">
    <asw-tooltip
      iconImage='<img src={{appConstants.IMG.ALL_HELP_PRIMARY}} alt="tooltip" width="20" height="20">'
      [tooltipContent]="i + '番目'"
      [tooltipTop]="0"
    >
    </asw-tooltip>
  </span>
  <h3>######## ツールチップ表示方式: アイコンホバー(2番目はdisplayAreaClassを指定)</h3>
  <ul class="c-icon-tooltip-list">
    <li class="c-icon-tooltip-list__item">
      <asw-tooltip
        iconImage='<img src="/../assets/images/icon_meal_24.svg" alt="tooltip" width="24" height="24">'
        tooltipContent="meal"
        tooltipDisplayType="hover"
        [tooltipTop]="0"
      >
      </asw-tooltip>
    </li>
    <li class="c-icon-tooltip-list__item">
      <asw-tooltip
        iconImage='<img src="/../assets/images/icon_entertainment_24.svg" alt="tooltip" width="24" height="24">'
        tooltipContent="entertainment"
        tooltipDisplayType="hover"
        [tooltipTop]="0"
        displayAreaClass="c-icon-tooltip-list"
      >
      </asw-tooltip>
    </li>
    <li class="c-icon-tooltip-list__item">
      <asw-tooltip
        iconImage='<img src="/../assets/images/icon_shopping_24.svg" alt="tooltip" width="24" height="24">'
        tooltipContent="shopping"
        tooltipDisplayType="hover"
        [tooltipTop]="0"
      >
      </asw-tooltip>
    </li>
  </ul>
  <div class="l-core-contents__inner l-core-contents__inner--full">
    <div class="l-core-contents__main">
      <div class="sample-codeBox">
        <div class="sample-codeBox__title">ツールチップボタン</div>
        <div class="sample-codeBox__object">
          <div class="view" style="margin-left: 30%">
            <asw-tooltip
              iconImage="下に表示(tooltipTopを負の値に設定))"
              tooltipContent='<p>運航便によりご利用のターミナルが異なりますのでご注意ください。
                <a href="#">羽田空港の発着ターミナルについて<img src="/../assets/images/icon_external_primary_16.svg" class="c-text-link-external" alt="test" width="16" height="16"></a>をご確認ください。</p>'
              [tooltipTop]="-80"
            >
            </asw-tooltip>
          </div>
          <div class="view" style="margin-left: 25%">
            <asw-tooltip
              iconImage="ボタン"
              tooltipContent='<p>運航便によりご利用のターミナルが異なりますのでご注意ください。
                <a href="#">羽田空港の発着ターミナルについて<img src="/../assets/images/icon_external_primary_16.svg" class="c-text-link-external" alt="test" width="16" height="16"></a>をご確認ください。</p>'
              [tooltipTop]="0"
            >
            </asw-tooltip>
          </div>
          <div class="view">
            <asw-tooltip iconImage="ボタン" tooltipContent="この便は予約可能です" [tooltipTop]="0"> </asw-tooltip>
          </div>
          <div class="view" style="text-align: right; margin-bottom: 30px">
            <asw-tooltip iconImage="ボタン" tooltipContent="この便は予約可能です" [tooltipTop]="0"> </asw-tooltip>
          </div>
          <div class="view" style="text-align: right; margin-bottom: 30px">
            <asw-tooltip
              iconImage="ボタン"
              tooltipContent='<p>運航便によりご利用のターミナルが異なりますのでご注意ください。
                  <a href="#">羽田空港の発着ターミナルについて<img src="/../assets/images/icon_external_primary_16.svg" class="c-text-link-external" alt="test" width="16" height="16"></a>をご確認ください。</p>'
              [tooltipTop]="0"
            >
            </asw-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="component-area" style="margin-bottom: 20px; width: 300px; height: 300px">
  <div class="l-core-contents__inner l-core-contents__inner--full">
    <div class="l-core-contents__main">
      <div class="sample-codeBox">
        <div class="sample-codeBox__title">ツールチップボタン</div>
        <div class="sample-codeBox__object">
          <div class="view">
            <asw-tooltip
              iconImage="l-core-contents__innerのwidth が小さいなかで表示"
              tooltipContent='<p>運航便によりご利用のターミナルが異なりますのでご注意ください。
                  <a href="#">羽田空港の発着ターミナルについて<img src="/../assets/images/icon_external_primary_16.svg" class="c-text-link-external" alt="test" width="16" height="16"></a>をご確認ください。</p>'
              [tooltipTop]="-80"
            >
            </asw-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
